<template>
    <v-expansion-panel
      @click="onDateTimePanelClick()"
      :class="disabled ? 'v-expansion-panel--disabled' : ''"
      :readonly="disabled"
    >
      <v-expansion-panel-header
        class="process-step-header"
        color="primary-color"
        id="dateTimePanel"
        ref="calendarStep"
      >
      <v-container>
        <v-row no-gutters>
            <v-col cols="2" sm="1">
              <div class="process-number">{{processNumber}}</div></v-col>
            <v-col cols="10" sm="11">
              <div class="process-step-name">{{messages.selectDateTimeStep}}</div>
              <div v-if="displaySelectedDateTime" class="chosen-options">
                <small>
                  <div>{{selectedDate | formatDate(selectedLanguage)}} {{selectedTimeSlot | formatTime(selectedLanguage)}}</div>
                </small>
              </div>
              <span role="log" aria-live="polite" class="screen-reader-only">
                  <div v-if="selectedDate && selectedTimeSlot">{{messages.ariaDataSelected}} {{selectedDate | formatDate(selectedLanguage)}} {{selectedTimeSlot | formatTime(selectedLanguage)}}</div>
              </span>
            </v-col>
          </v-row>
      </v-container>
      <span aria-live="polite" class="screen-reader-only">{{messages.selectDateTimeStep}} {{ stepExpanded ? messages.ariaExpanded : messages.ariaCollapsed }}</span>
      <span aria-live="polite" class="screen-reader-only">
        <div v-if="selectedDate && stepExpanded">{{ messages.ariaSelectedDate }} {{selectedDate | formatDate(selectedLanguage)}}</div>
      </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content v-if="!disabled">
        <v-card>
          <v-card-text class="info-text" v-html="messages.selectDateTimeContentText"></v-card-text>
          <time-selection
            v-if="loadCalendar"
            :reschedule="false"
            @time-selected="timeSelected"
            @timeslot-cleared="timeslotCleared"
            @is-loaded="$emit('is-loaded')"
            :stepExpanded = "stepExpanded"
            :rereserve-timeslot-key = "rereserveTimeslotKey"
          ></time-selection>
        </v-card>
      </v-expansion-panel-content>
      <v-alert v-if="disabled" ref="disabled" v-model="showDisabledAlert" class="alert-error" close-label="Close Alert" tile type="error" role="alert" dismissible>
        {{messages.disabledStepBranchOrServiceMissing}}
      </v-alert>
    </v-expansion-panel>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import TimeSelection from '../components/TimeSelection'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'DateTimeSelectionStep',
  props: [
    'disabled',
    'processNumber',
    'loadCalendar',
    'displaySelectedDateTime',
    'currentPanelOpen',
    'rereserveTimeslotKey'
  ],
  components: {
    TimeSelection
  },
  data: () => ({
    stepExpanded: null,
    attempts: 0,
    showDisabledAlert: false
  }),
  watch: {
    currentPanelOpen () {
      if (this.currentPanelOpen === 2) {
        this.stepExpanded = true
      } else {
        this.stepExpanded = false
      }
    }
  },
  computed: {
    ...mapState([
      'configuration',
      'selectedDate',
      'selectedTimeSlot',
      'messages',
      'selectedLanguage',
      'funcDebug'
    ])
  },
  methods: {
    ...mapActions([
      'resetSelectedDateAndTimeSlot',
      'setSelectedDate',
      'setSelectedTimeSlot',
      'setContactDetails',
      'resetContactDetails',
      'resetBookingStore',
      'setReservedAppointmentId',
      'resetReservedAppointmentId'
    ]),
    timeslotCleared () {
      this.$emit('update:displaySelectedDateTime', false)
      this.resetReservedAppointmentId()
      this.resetSelectedDateAndTimeSlot()
      this.$emit('check-steps')
    },
    timeSelected (timeslot, date, appointmentId) {
      if (this.funcDebug) console.log('DateTimeSelectionStep:methods:timeSelected')
      this.setSelectedDate(date)
      this.setSelectedTimeSlot(timeslot)
      this.setReservedAppointmentId(appointmentId)
      this.$emit('update:displaySelectedDateTime', false)
      this.$emit('data-selected', 'date-time')
    },
    setfocus () {
      if (this.funcDebug) console.log('DateTimeSelectionStep:methods:setfocus')
      this.$nextTick(() => {
        if (this.$refs.calendarStep) {
          this.$refs.calendarStep.$el.focus()
        } else {
          this.attempts = 0
          this.retryfocus()
        }
      })
    },
    retryfocus () {
      if (this.funcDebug) console.log('DateTimeSelectionStep:methods:retryfocus')
      this.attempts++
      if (this.attempts < 5) {
        // setTimeout(() => {
        this.$nextTick(() => {
          if (this.$refs.calendarStep) {
            this.$refs.calendarStep.$el.focus()
          } else {
            this.retryfocus()
          }
        })
      // }, 200)
      }
    },
    onDateTimePanelClick () {
      if (this.disabled) {
        this.showDisabledAlert = true
      }
    }
  },
  mounted () {
    if (this.funcDebug) console.log('DateTimeSelectionStep:mounted')
    eventHub.$on('date-time-step-focus', this.setfocus)
    this.stepExpanded = false
  }
}
</script>
